export class SureFlowRatingCircuitResponse {

  id!: number;
  fullLoadAmps!: number;
  minimumCircuitAmps!: number;
  maximumFuseSize!: number;
  outputPower!: number;
  horsepowerValue!: number;

}
